import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActionHandler } from './action-handler';
import { ChangeOfServicejobActionHandler } from './action-handlers/change-of-servicejob-action-handler.service';
import { EndOfPauseActionHandler } from './action-handlers/end-of-pause-action-handler.service';
import { EndOfServicejobActionHandler } from './action-handlers/end-of-servicejob-action-handler.service';
import { EndOfWaitActionHandler } from './action-handlers/end-of-wait-action-handler.service';
import { EndOfWorkActionHandler } from './action-handlers/end-of-work-action-handler.service';
import { ExportLogActionHandler } from './action-handlers/export-log-action-handler.service';
import { FinishTourActionHandler } from './action-handlers/finish-tour-action-handler.service';
import { HomeActionHandler } from './action-handlers/home-action-handler.service';
import { LogoutActionHandler } from './action-handlers/logout-action-handler.service';
import { NavigateDoActionHandler } from './action-handlers/navigate-do-action-handler.service';
import { NavigateWoActionHandler } from './action-handlers/navigate-wo-action-handler.service';
import { NotifyTravelEndActionHandler } from './action-handlers/notify-travel-end-action-handler.service';
import { NotifyTravelStartActionHandler } from './action-handlers/notify-travel-start-action-handler.service';
import { PhotodocuActionHandler } from './action-handlers/photodocu-action-handler.service';
import { PopoverJobSectionInstanceDynFormActionHandler } from './action-handlers/popover-jobsection-instance-dyn-form-action-handler.service';
import { PopoverMultiInstanceDynFormActionHandler } from './action-handlers/popover-multi-instance-dyn-form-action-handler.service';
import { ResetActionHandler } from './action-handlers/reset-action-handler.service';
import { StartNavigateActionHandler } from './action-handlers/start-navigate-action-handler.service';
import { StartOfPauseActionHandler } from './action-handlers/start-of-pause-action-handler.service';
import { StartOfServicejobActionHandler } from './action-handlers/start-of-servicejob-action-handler.service';
import { StartOfWaitActionHandler } from './action-handlers/start-of-wait-action-handler.service';
import { StartOfWorkActionHandler } from './action-handlers/start-of-work-action-handler.service';
import { SyncActionHandler } from './action-handlers/sync-action-handler.service';
import { SyncJobsActionHandler } from './action-handlers/sync-jobs-action-handler.service';
import { SyncPinsActionHandler } from './action-handlers/sync-pins-action-handler.service';
import { SyncTagStatesActionHandler } from './action-handlers/sync-tag-states-action-handler.service';
import { TakeOverTourActionHandler } from './action-handlers/take-over-tour-action-handler.service';
import { WorkTypeChangeActionHandler } from './action-handlers/work-type-change-action-handler.service';
import { GeneralActionInterpreterService } from './general-action-interpreter/general-action-interpreter.service';
import { PhotoGalleryActionHandler } from './action-handlers/photo-gallery-action-handler.service';
import { ReinitActionHandler } from './action-handlers/reinit-action-handler.service';
import { DriverPassengerIdentificationActionHandler } from './action-handlers/driver-passenger-identification-action-handler.service';
import { SyncDeficiencyActionHandler } from './action-handlers/sync-deficiency-tickets-action-handler.service';
import { SyncExtFilesActionHandler } from './action-handlers/sync-ext-files-action-handler.service';
import { SyncActivityConfirmationsActionHandler } from './action-handlers/sync-activity-confirmations-action-handler.service';
import { OpenExtFileActionHandler } from './action-handlers/open-extfile-action-handler.service';
import { RequestBluetoothPermissionActionHandler } from './action-handlers/request-bluetooth-permission-action-handler.service';
import { SyncPeripheralsActionHandler } from './action-handlers/sync-peripherals-action-handler.service';
import { HardResetActionHandler } from './action-handlers/hard-reset-action-handler.service';
import { StartOfTourActionHandler } from './action-handlers/start-of-tour-action-handler.service';
import { ChangeTourActionHandler } from './action-handlers/change-tour-action-handler.service';
import { StopArrivalActionHandler } from './action-handlers/stop-arrival-action-handler.service';
import { FinishedServicejobActionHandler } from './action-handlers/finished-servicejob-action-handler.service';
import { SyncJobSectionsActionHandler } from './action-handlers/sync-jobsections-action-handler.service';
import { UpdateActivityConfirmationActionHandler, LegacyUpdateAcuKeyActionHandler } from './action-handlers/update-activity-confirmation-action-handler.service';
import { PassengerTripEndActionHandler } from './action-handlers/passenger-trip-end-action-handler.service';
import { ClearLogActionHandler } from './action-handlers/clear-log-action-handler.service';
import { LogTerminalConnectionProblemActionHandler } from './action-handlers/log-terminal-connection-problem-action-handler.service';
import { OpenTempFileActionHandler } from './action-handlers/open-tempfile-action-handler.service';
import { ObjectSelectModalComponentModule } from 'src/app/_components/object-select-modal/object-select-modal.module';
import { PhotoViewModalComponentModule } from 'src/app/_components/photo-view-modal/photo-view-modal.module';
import { StartOfSteeringPauseActionHandler } from './action-handlers/start-of-steering-pause-action-handler.service';
import { EndOfSteeringPauseActionHandler } from './action-handlers/end-of-steering-pause-action-handler.service';
import { StartOfRestingPauseActionHandler } from './action-handlers/start-of-resting-pause-action-handler.service';
import { EndOfRestingPauseActionHandler } from './action-handlers/end-of-resting-pause-action-handler.service';
import { MileageActionHandler } from './action-handlers/mileage-action-handler.service';
import { ReceivedMessageActionHandler } from './action-handlers/received-message-action-handler.service';
import { PeripheralGalleryActionHandler } from './action-handlers/peripheral-gallery-action-handler.service';
import { RequestWifiPermissionActionHandler } from './action-handlers/request-wifi-permission-action-handler.service';
import { SyncObjectIdLabelActionHandler } from './action-handlers/sync-object-id-label-action-handler.service';
import { JobIdentificationActionHandler } from './action-handlers/job-identification-action-handler.service';
import { ExtDocActionHandler } from './action-handlers/ext-doc-action-handler.service';
import { NewDraftAvailableActionHandler } from './action-handlers/new-draft-available-action-handler.service';
import { DraftRevokedActionHandler } from './action-handlers/draft-revoked-action-handler.service';
import { DraftFinalizedActionHandler } from './action-handlers/draft-finalized-action-handler.service';
import { DraftDeletedActionHandler } from './action-handlers/draft-deleted-action-handler.service';
import { DraftDiscardedActionHandler } from './action-handlers/draft-discarded-action-handler.service';
import { SyncProjectContactDirectoryActionHandler } from './action-handlers/sync-project-contact-directory-action-handler.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, ObjectSelectModalComponentModule, PhotoViewModalComponentModule],
  providers: [
    {
      provide: ActionHandler,
      useExisting: ChangeOfServicejobActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: EndOfPauseActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: EndOfServicejobActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: EndOfWaitActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: EndOfWorkActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: ExportLogActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: LogoutActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: NavigateDoActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: NavigateWoActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: NotifyTravelEndActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: NotifyTravelStartActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: ResetActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: HardResetActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: StartNavigateActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: StartOfPauseActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: StartOfServicejobActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: StartOfWaitActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: StartOfWorkActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: SyncActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: SyncJobsActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: SyncPinsActionHandler,
      multi: true,
    },

    {
      provide: ActionHandler,
      useExisting: SyncDeficiencyActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: WorkTypeChangeActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: HomeActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: PopoverMultiInstanceDynFormActionHandler,
      multi: true,
    },

    {
      provide: ActionHandler,
      useExisting: PopoverJobSectionInstanceDynFormActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: TakeOverTourActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: FinishTourActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: PhotodocuActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: SyncTagStatesActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: PhotoGalleryActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: ReinitActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: DriverPassengerIdentificationActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: SyncExtFilesActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: SyncActivityConfirmationsActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: OpenExtFileActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: RequestBluetoothPermissionActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: SyncPeripheralsActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: StartOfTourActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: ChangeTourActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: StopArrivalActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: FinishedServicejobActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: SyncJobSectionsActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: UpdateActivityConfirmationActionHandler,
      multi: true,
    },
    // Deprecated alias for the renamed 'updateacukey' target - see the handler
    {
      provide: ActionHandler,
      useExisting: LegacyUpdateAcuKeyActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: PassengerTripEndActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: ClearLogActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: LogTerminalConnectionProblemActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: OpenTempFileActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: StartOfSteeringPauseActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: EndOfSteeringPauseActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: StartOfRestingPauseActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: EndOfRestingPauseActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: MileageActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: ReceivedMessageActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: PeripheralGalleryActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: RequestWifiPermissionActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: SyncObjectIdLabelActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: JobIdentificationActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: ExtDocActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: NewDraftAvailableActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: DraftRevokedActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: DraftFinalizedActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: DraftDeletedActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: DraftDiscardedActionHandler,
      multi: true,
    },
    {
      provide: ActionHandler,
      useExisting: SyncProjectContactDirectoryActionHandler,
      multi: true,
    },
    GeneralActionInterpreterService,
  ],
})
export class ActionInterpreterModule {}
